module.exports = __webpack_public_path__ + "images/emoji/steam_locomotive.3346e38425b02afb2559.png";